import PropTypes from 'prop-types';
// material-ui
import Checkbox from '@mui/material/Checkbox';
import { is } from 'date-fns/locale';

// ==============================|| ROW SELECTION - CHECKBOX ||============================== //
export const getRowColor = (dueDateString, isActive = true) => {
  if (isActive === false) {
    return '#5B6B79';
  }
  // Extract the valid date part (ignore the day of the week)
  const cleanedDateString = dueDateString.split(',')[0].trim();

  const dueDate = new Date(cleanedDateString);
  if (isNaN(dueDate)) {
    console.error(`Invalid date format: ${dueDateString}`);
    return 'green';
  }

  const today = new Date();
  const timeDiff = dueDate - today; // Difference in milliseconds
  const dayDiff = timeDiff / (1000 * 60 * 60 * 24); // Convert to days

  if (dayDiff > 7) {
    // Future date more than 7 days
    // return 'blue';
    return '#295faa';
  } else if (dayDiff < 0) {
    // Due date expired
    // return 'red'; 
    return '#f44336'; // Due date expired //#ff4b72
  }
  // return 'green'; // Default color
  //Future date within 7 days
  return '#96ca53';
};
export default function IndeterminateCheckbox({ indeterminate, dateValue, ...rest }) {
  const checkboxColor = dateValue && getRowColor(dateValue);
  return <Checkbox {...rest} indeterminate={typeof indeterminate === 'boolean' && !rest.checked && indeterminate} sx={{
    color: checkboxColor,
    '&.Mui-checked': {
      color: checkboxColor,
    },
    '&.MuiCheckbox-indeterminate': {
      color: checkboxColor,
    },
    '&.MuiCheckbox-colorPrimary svg': {
      color: checkboxColor + ' !important',
    },
  }} />;
}

IndeterminateCheckbox.propTypes = { indeterminate: PropTypes.bool };
